import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  AlertController,
  ModalController,
  PopoverController,
} from '@ionic/angular';
import { PlatformEnum, PlatformService } from '@panamax/app-state';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Order, OrderStatus } from '@usf/ngrx-order';
import { DateService } from '@shared/services/date.service';
import { DownloadFileTypes } from '@shared/constants/order-download-file';
import { OrderStatusDetails } from '@shared/constants/order-status-title.enum';
import { FileEntity } from '@shared/models/file-entity';
import { DownloadOrdersEvent } from '@order/models/download-orders-event';

@Component({
  selector: 'app-download-order-modal',
  templateUrl: './download-order-modal.component.html',
  styleUrls: ['./download-order-modal.component.scss'],
})
export class DownloadOrderModalComponent implements OnInit {
  @Input() title: string;
  @Input() orders: Order[];
  @Input() fileTypes: FileEntity[] = [
    DownloadFileTypes.CMP,
    DownloadFileTypes.CSV,
    DownloadFileTypes.STD,
    DownloadFileTypes.STD2,
    DownloadFileTypes.XML,
  ];
  @Input() fileName: string;
  @Input() platform: PlatformEnum;
  @Input() showOrdersDropdown = true;

  @Output() isOpenEmitter = new EventEmitter<boolean>();
  @Output() downloadOrdersEmitter = new EventEmitter<DownloadOrdersEvent>();
  @Output() dismissEvent: EventEmitter<void> = new EventEmitter();

  readonly PlatformEnum = PlatformEnum;
  isOrderDownloadPopoverOpen: boolean;
  isFileTypePopoverOpen: boolean;
  downloadOrderForm: FormGroup;
  fileType: string;
  downloadOptions: string;

  selectPopoverOptions = {
    showBackdrop: false,
    cssClass: 'download-order-popover',
    mode: 'ios',
    alignment: 'center',
  };

  multiSelectPopoverOptions = {
    showBackdrop: false,
    cssClass: 'download-order-popover-multi',
    mode: 'ios',
    alignment: 'center',
  };

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.isFileTypePopoverOpen = false;
    this.isOrderDownloadPopoverOpen = false;

    const defaultOrder = this.orders[0];

    const fileName =
      this.fileName ??
      `Submitted_Order${defaultOrder?.orderHeader?.tandemOrderNumber}_Cust${
        defaultOrder?.orderHeader?.customerNumber
      }_${DateService.formatDateMaintainUTC(
        defaultOrder?.orderHeader?.confirmedDeliveryDate,
        '',
      )}`;

    this.downloadOrderForm = this.fb.group({
      fileName: new FormControl(fileName, [Validators.required]),
      fileType: new FormControl(this.fileTypes[0]?.fileExtension ?? 'CMP'),
      downloadOptions: new FormControl(
        this.orders.map(order => order?.orderHeader?.orderId?.toString()),
      ),
    });
  }

  submit() {
    const selectedOrders = this.orders.filter(order =>
      this.downloadOrderForm.controls['downloadOptions'].value.includes(
        order.orderHeader.orderId?.toString(),
      ),
    );

    const fileType =
      DownloadFileTypes[this.downloadOrderForm.controls['fileType'].value];

    this.dismiss();
    this.downloadOrdersEmitter.emit({
      fileName: this.downloadOrderForm.controls['fileName'].value,
      fileType: fileType,
      orders: selectedOrders,
    });
  }

  dismiss() {
    this.dismissEvent.emit();
  }

  getOrderStatusTitle(orderStatus: string, isDelivered: boolean) {
    return isDelivered ? 'Delivered' : OrderStatusDetails[orderStatus].title;
  }
}
